import _ from 'lodash'

// support partner-api
export const getBasicPlanCodeForMRTA = (product) => {
  return _.defaultTo(_.get(product, '_basicPlanCode'), _.get(product, 'basicPlanCode', ''))
}

export const getProductCodeForMRTA = (displayProduct) => {
  let code
  if (!_.isEmpty(_.get(displayProduct, '_basicPlanCode'))) {
    code = _.get(displayProduct, 'basicPlanCode', '')
  } else {
    code = _.get(displayProduct, 'code', '')
  }
  return code
}
